module.exports = __webpack_public_path__ + "img/4.cff4ad82.jpg";